import { selectAll, addClass, removeClass } from "../utils/utils";
import Swiper from 'swiper/bundle';

export class GridCards {
  constructor(el) {
    if (el) {
      this.init(el);
    }
  }

  init(el) {
    this.el = el;
    this.props();
    this.render();
  }

  props() {
    this.openCardEl = selectAll("[data-open-grid-card]");
    this.teamCarouselContainer = selectAll("[data-science-carousel]");
  }

  render() {
    this.openCard();
    this.cardCarousel();
  }

  openCard = () => {

    for (var i = 0; i < this.openCardEl.length; i++) {
      this.openCardEl[i].addEventListener("click", function () {
        const sibling = this.previousElementSibling;
        const children = sibling.children[0];
        if (this.classList.contains("active")) {
          removeClass(this, "active");
          children.hidden = true;
          this.setAttribute("aria-expanded", false);
          children.setAttribute("tabindex", "-1");
        } else {
          addClass(this, "active");
          children.hidden = false;
          this.setAttribute("aria-expanded", true);
          children.setAttribute("tabindex", "1");
        }

      });
    };

  }

  cardCarousel = () => {
    for (var i = 0; i < this.teamCarouselContainer.length; i++) {
      new Swiper(this.teamCarouselContainer[i], {
        slidesPerView: 1.3,
        spaceBetween: 32,
        scrollbar: {
          el: '.swiper-scrollbar',
          draggable: true,
        },
      });
    };


  };
}